/**
 * Created by Qingger Corp.
 * User: Thinkpad
 * Date: 2019/6/6
 * Time: 16:28
 * Desc: 虚拟店长管理
 */

import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import moment from 'moment';
import childList from './childList';
import { IPSService } from '@/services/ipsServices';
import { appEnvConfig } from '@/configs/appConfigs';
import { Functions } from '@/library/utils/functions';
import NoAuth from '@/views/components/noAuth/noAuth.vue';
import { PolicyTypeText } from '@/views/components/newDistribution/newDistributionList';
import { noop, parseSec, showPlatform } from '@/util';
import imagePreview from '@/views/components/imgPreview';
import importBatchSet from '@/views/components/importBatchSet';
import Socket from '@/library/socket';
import ExportFile from '@/views/components/exportFile';
import NewSelectSite from '@/views/components/newSelectSIte';
@Component({
  components: {
    NoAuth,
    ExportFile,
  },
})
export default class VirtualManager extends Vue {
  $refs: {
    form: ElForm;
  };

  /**
   * loading状态
   * @type {boolean}
   */
  public loadingState = false;

  /**
   * 商品列表
   * @type {Array<ItemObject>}
   */
  public managerList: Array<DistributorInfo> = [];
  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 10;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 是否选中活动
   * @type {boolean}
   */
  public isSelected = false;

  /**
   * 关键字
   * @type {string}
   */
  public keyword = '';

  public identity = '';

  /**
   * 排序名称
   * @type {string}
   */
  public order = '';

  /**
   * 排序方式
   * @type {string}
   */
  public orderBy = '';

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = false;

  /**
   * 标签筛选条件
   * @type {string}
   */
  public queryParamTag = '9'; // 0 普通顾客、1 公司员工、2 公司导购、3 签约网红、4 黄牛 9 全部

  /**
   * 修改目标姓名
   * @type {string}
   */
  public editInfo: ItemObject = {};

  /**
   * 批量修改身份标签弹窗
   * @type {boolean}
   */
  public showBatchEditIdentity = false;

  /**
   * 树结构列表
   */
  siteTreeList: ItemArray = [];

  /**
   * 角色标签类型
   * @type {string | number}
   */
  public tagType = '';

  /**
   * 角色标签列表
   * @type {ItemArray}
   */
  public tagTypeList = [];

  /**
   * 分销类型列表
   * @type {ItemArray}
   */
  public distributionTypeList = PolicyTypeText;

  /**
   * 状态类型
   * @type {number | string}
   */
  public openState = '';

  /**
   * 网点列表
   * @type {string[]}
   */
  public siteCodes: string[] = [];

  /**
   * 分销类型
   * @type {number | string}
   */
  public distributionType = '';

  /**
   * 状态列表
   * @type {ItemArray}
   */
  public stateList = [
    { value: 0, label: '禁用' },
    { value: 1, label: '正常' },
    { value: -1, label: '已注销' },
    { value: 9, label: '全部' },
  ];

  /**
   * 分销员详情
   * @type {ItemObject}
   */
  public distributorInfo: ItemObject = {};

  /**
   * 分销策略
   * @type {number | string}
   */
  public deistribution = '';

  /**
   * 分销策略列表
   * @type {ItemArray}
   */
  public distributionList = [];

  // 免审提现列表
  public noCheckCashList = [
    { name: '跟随店铺设置', key: 0 },
    { name: '开启', key: 1 },
    { name: '关闭', key: 2 },
  ];

  /**
   *
   * 分销员详情弹窗
   * @type {boolean}
   */
  public showDistributorInfo = false;

  /**
   * 变更履历弹窗
   * @type {boolean}
   */
  public showHistory = false;

  /**
   * 变更履历列表
   * @type {ItemArray}
   */
  public changeHistoryList = [];

  /**
   * moment
   */
  public moment = moment;

  /**
   * 变更履历页码
   * @type {number}
   */
  public historyPage = 1;

  /**
   * 变更履历每页数量
   * @type {number}
   */
  public historyPageSize = 10;

  /**
   * 变更履历总数
   * @type {number}
   */
  public historyTotalCount = 0;

  /**
   * 选中的分销员
   */
  public selectedDistributor = [];
  // 列表的key
  public key = 0
  // dialog的key值
  keydialog = 0
// 是否展示银行卡
  isShowBank = false

  /* 方法 */

  /**
   * 获取分销商品列表
   * @return null
   */
  public onSearchManageList(): void {
    this.page = 1;
    this.pageSize = 10;
    this.selectedDistributor = [];
    this.onGetManagerList();
  }

  /**
   * 条数变更
   * @param {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.onGetManagerList();
  }

  /**
   * 页码变更
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.onGetManagerList();
    this.selectedDistributor = [];
  }

  /**
   * 分销类型改变
   * @param {number} val
   */
  public distributionTypeChange(val) {
    this.distributionType = val;
    this.selectedDistributor = [];
    this.onGetManagerList();
  }

  /**
   * 角色标签改变
   * @param {number} val
   */
  public tagTypeChange(val) {
    this.selectedDistributor = [];
    this.tagType = val;
    this.onGetManagerList();
  }

  /**
   * 状态改变
   * @param {number} val
   */
  public openStateChange(val) {
    this.selectedDistributor = [];
    this.openState = val;
    this.onGetManagerList();
  }

  /**
   * 选中的活动
   * @param val
   * @return null
   */
  public onHandleSelectionChange(val): void {
    this.isSelected = val.length > 0;
  }

  /**
   * 去往虚拟店长信息页面
   * @param {number} id
   * @param {string} name
   * @return null
   */
  public onGoToVirtualManagerInfo(siteId, policyType, vGuiderId: number, name): void {
    this.getDistributionList(siteId, policyType).then(() => {
      IPSService.dsitributorInfo({
        postParams: {
          vGuiderId,
        },
      }).then((response) => {
        response.policyId = response.policyId || '';
        this.distributorInfo = response;
        this.keydialog = Math.random()
        this.showDistributorInfo = true;
      });
    });
  }

  /**
   * 获取左侧树列表
   * @return null
   */
  // getTreeList() {
  //   return IPSService.getAdminAuthTree().then((response) => {
  //     return response.treeList;
  //   });
  // }
  openSelectSiteDialog() {
    new NewSelectSite().open({
      service: 'authTree',
      selectCodes: this.siteCodes,
      readonly: false,
    }).then((val: string[]) => {
      this.siteCodes = val;
      this.onGetManagerList()
      this.getTagList()
    }, noop);
  }
  /**
   * 获取虚拟店长列表
   * @return null
   */
  public async onGetManagerList() {
    const loading = this.$loading({
      lock: true,
      text: '请稍等...',
      spinner: 'el-icon-loading',
      background: 'rgba(225,225,225,0.3)',
    });
    const postParams = {
      page: this.page,
      pageSize: this.pageSize,
      keyword: this.keyword,
      siteCodes: this.siteCodes,
      policyType: this.distributionType === '' ? 9 : this.distributionType,
      tagName: `${this.tagType}` ? this.tagTypeList[this.tagType] || '' : '',
      openState: this.openState === '' ? 9 : this.openState,
    };
    // if (!this.siteTreeList || !this.siteTreeList.length) {
    //   this.siteTreeList = await this.getTreeList();
    // }
    this.ipsGetList(postParams, loading);
  }

  ipsGetList(postParams, loading) {
    IPSService.dsitributorList({ postParams }).then(
      (res) => {
        loading.close();
        // 格式化数据
        if (res.list.length > 0) {
          res.list.forEach((item) => {
            item.tagName = Functions.emptyVaribleHandler(item.tagName);
            item.bankCardCode=item.bankCardInfo.bankCardCode?item.bankCardInfo.bankCardCode:'';
            item.bankName=Functions.emptyVaribleHandler(item.bankCardInfo.bankName);
          });
        }
        this.managerList = res.list;
        this.key = Math.random()
        this.totalCount = res.count;
      },
      () => {
        loading.close();
      },
    );
  }

  /**
   * 点击树节点时
   * @param {ItemObject} item
   */
  // onClickNode(item) {
  //   this.page = 1;
  //   this.pageSize = 10;
  //   this.siteCodes = this.getTreeAllSite(item);
  //   this.isSelected = false;
  //   this.tagType = '';
  //   this.getTagList();
  //   this.onGetManagerList();
  // }

  /**
   * 获取该节点下所有code
   * @returns {string[]}
   */
  // getTreeAllSite(data) {
  //   const childSite = [];
  //   const deepSearch = (node) => {
  //     if (node.isSite) {
  //       childSite.push(node.code);
  //       return;
  //     } else if (Array.isArray(node.children) && node.children.length) {
  //       node.children.forEach((i) => {
  //         deepSearch(i);
  //       });
  //     }
  //   };
  //   deepSearch(data);
  //   return childSite;
  // }

  /**
   * 虚拟店长列表排序
   * @param {ItemObject} column
   * @return null
   */
  public onSortChange(column: ItemObject): void {
    this.order = column.prop;
    this.orderBy = column.order === 'ascending' ? 'ASC' : 'DESC';
    this.onGetManagerList();
  }

  /**
   * 虚拟店长的状态变更
   * @param {number} id
   * @param {number} openState
   * @return null
   */
  public onVirtualManagerStateChange(id: number, openState: number, buyerName: string): void {
    const postParams = {
      vGuiderIds: [id],
      openState,
    };
    this.$confirm(`是否${openState ? '启' : '禁'}用${buyerName}的分销员身份?`, { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        IPSService.distributorUpdateState({ postParams }).then((res) => {
          if (res) {
            this.$message.success(`${openState ? '启' : '禁'}用成功`);
            this.onGetManagerList();
          } else {
            this.$message.success(`${openState ? '启' : '禁'}用失败`);
          }
        });
      }
    }, noop);
  }

  /**
   * 获取角色标签列表
   * @return null
   */
  public getTagList() {
    IPSService.guiderTagList({
      postParams: {
        siteCode: this.siteCodes,
      },
    }).then((response) => {
      this.tagTypeList = response.list;
    });
  }

  /**
   * 批量修改
   * @return null
   */
  public batchEdit() {
    importBatchSet
      .open({
        title: '批量修改',
        fromKey: 'distributor',
        postParams: {
          siteCodes: this.siteCodes,
          keyword: this.keyword,
          policyType: this.distributionType === '' ? 9 : this.distributionType,
          tagName: `${this.tagType}` ? this.tagTypeList[this.tagType] : '',
          openState: this.openState === '' ? 9 : this.openState,
        },
        empCode: this.$store.state.empCode,
        importUrl: `${Functions.ipsHostUrlApi()}/admin/distributor/change/import`,
        excelHeader: [
          { header: '姓名', key: 'buyerName', width: 15 },
          { header: '手机号', key: 'buyerPhone', width: 25 },
          { header: '身份证号', key: 'buyerCardNumber', width: 25 },
          { header: '所属网点', key: 'siteInfo', width: 15 },
          { header: '分销策略ID', key: 'policyId', width: 15 },
        ],
        name: '批量修改模板',
      })
      .then((result) => { }, noop);
  }

  /**
   * 打开变更履历
   * @return null
   */
  public getChangeHistory() {
    IPSService.distributorChangeHistory({
      postParams: {
        vGuiderId: this.distributorInfo.vGuiderId,
        page: this.historyPage,
        pageSize: this.historyPageSize,
      },
    }).then((response) => {
      this.changeHistoryList = response.list.map((v) => {
        v.updateTime = moment(v.updateTime * 1000).format('YYYY-MM-DD HH:mm');
        return v;
      });
      this.historyTotalCount = response.count;
      this.showHistory = true;
    });
  }

  /**
   * 每页显示数量变更
   * @param {number} val
   */
  public onHistorySizeChange(val) {
    this.historyPageSize = val;
    this.getChangeHistory();
  }

  /**
   * 页码变更
   * @param {number} val
   */
  public onHistoryPageChange(val) {
    this.historyPage = val;
    this.getChangeHistory();
  }

  /**
   * 获取分销策略列表
   * @return null
   */
  public getDistributionList(siteId, policyType, openState = 1) {
    return IPSService.newDistributionList({
      postParams: {
        siteId,
        policyType,
        openState,
      },
    }).then((response) => {
      this.distributionList = response.list;
    });
  }

  /**
   * 保存分销员分销策略
   * @return null
   */
  public onSave() {
    if (!this.distributorInfo.policyId) {
      this.$message.warning('请选择分销策略');
      return;
    }
    if (this.distributorInfo.isAutomaticProfitOut == null) {
      this.$message.warning('请选择免审提现方式');
      return;
    }
    const postParams = {
      vGuiderId: this.distributorInfo.vGuiderId,
      policyId: this.distributorInfo.policyId,
      isAutomaticProfitOut: this.distributorInfo.isAutomaticProfitOut,
      isModify: this.distributorInfo.isModify,
    };
    IPSService.distributorChange({
      postParams,
    }).then((response) => {
      this.showDistributorInfo = false;
      this.onGetManagerList();
      if (response.result) {
        this.$message.success('保存成功');
      } else {
        this.$message.error('保存失败');
      }
    });
  }

  /**
   * 身份证预览
   * @param {string} url
   */
  public imagePreview(img) {
    imagePreview.open({ img }).catch(() => { });
  }

  /**
   * 注销分销员
   * @param {number} vGuiderId
   * @return null
   */
  public destoryDistributor(vGuiderId, buyerName) {
    this.$confirm(`是否注销${buyerName}的分销员身份,注销后不可恢复,只能重新申请`, '提示', {
      type: 'warning',
    }).then((result) => {
      if (result === 'confirm') {
        IPSService.distributorLogOut({
          postParams: {
            vGuiderIds: [vGuiderId],
          },
        }).then(() => {
          this.$message.success('注销成功');
          this.onGetManagerList();
        });
      }
    }, noop);
  }

  /**
   * 批量注销
   */
  public batchDestroy() {
    if (!this.selectedDistributor.length) {
      return;
    }
    this.$confirm(`确认将选中的${this.selectedDistributor.length}人批量注销？`, { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        IPSService.distributorLogOut({
          postParams: {
            vGuiderIds: this.selectedDistributor.map(v => v.vGuiderId),
          },
        }).then(() => {
          this.$message.success('注销成功');
          this.onGetManagerList();
        });
      }
    }, noop);
  }

  /**
   * 选中的分销员
   * @param val
   * @return null
   */
  public onSelected(val) {
    this.selectedDistributor = val;
  }

  /**
   * 是否可选
   * @param val
   * @return null
   */
  ckeckAble(row) {
    return row.openState == 0 || row.openState == 1;
  }

  /**
   * 批量修改状态
   * @param {number} state 0 禁用 1 启用
   * @return null
   */
  batchUpdateState(openState) {
    if (!this.selectedDistributor.length) {
      return;
    }
    this.$confirm(`确认将选中的${this.selectedDistributor.length}人批量${openState ? '启' : '禁'}用？`, {
      type: 'warning',
    }).then((result) => {
      if (result === 'confirm') {
        IPSService.distributorUpdateState({
          postParams: {
            vGuiderIds: this.selectedDistributor.map(v => v.vGuiderId),
            openState,
          },
        }).then(() => {
          this.$message.success(`${openState ? '启' : '禁'}用成功`);
          this.onGetManagerList();
        });
      }
    }, noop);
  }

  /**
   * 二级明细
   * @param vGuiderId
   */
  getChildDetail(vGuiderId: number) {
    (childList as any).open({ vGuiderId }).then(
      () => {
        this.onGetManagerList();
      },
      () => {
        this.onGetManagerList();
      },
    );
  }

  get exportParams() {
    const postParams = {
      exportType: 'distributor',
      params: {
        keyword: this.keyword,
        siteCodes: this.siteCodes,
        policyType: this.distributionType === '' ? 9 : this.distributionType,
        tagName: `${this.tagType}` ? this.tagTypeList[this.tagType] || '' : '',
        openState: this.openState === '' ? 9 : this.openState,
      },
    };
    return postParams;
  }

  public dateChange() {
    this.page = 1;
    this.onGetManagerList();
  }
  /**
   * 当组建创建时
   */
  public created() {
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-DISTRIBUTE-VIRGUIDER');
    if (this.isContentBodyShow) {
      const list = ['embryform', 'devtest2', 'really'];
      this.isShowBank = showPlatform(list)
      this.onGetManagerList(); // 获取虚拟店长列表
      this.getTagList(); // 获取角色标签列表
    }
  }
}
